import React from 'react';
import style from './style';
import EADialog from '../../../../components/common/EADialog';
import DossierCreation from '../../../dossiers/create-dossier';
import DossiersDataTable from '../../../../components/dossiers/DossiersDataTable';

const Dossiers = ({addDossierPopup, setAddDossierPopup, contextThirdparty, activeDossiers, refetch}) => {
  const { classes } = style();
  const onClose = () => {
    setAddDossierPopup(false);
  }

  const successCallback = () => {
    refetch();
    setAddDossierPopup(false);
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        {activeDossiers && (
          <DossiersDataTable
            dossiers={activeDossiers}
            monitored
            component="thirdparty"
            pageSize={10}
            multiDataGridPage
            sheetVariant={true}
            onDeactivation={() => refetch()}
            onVisibleRowsCountChange={(count) => {}
            }
            fromTp
          />
        )}
        <EADialog
          isOpen={addDossierPopup}
          onClose={onClose}
          displayBtn={false}
          crossVisible={true}

          maxWidth={'xl'}
          customDialogStyle={{width: '1000px', background: '#F2F3F7'}}
        >
          <DossierCreation
            origin={'context'}
            contextThirdparty={contextThirdparty}
            successCallback={successCallback}
          />
        </EADialog>
      </div>
    </div>
  );
};

export default Dossiers;
